export function getIsDeadlinePassed(dateDeadline: Date | null, now: Date | null) {
    if (!dateDeadline || !now) {
        return false;
    }

    return dateDeadline < now;
}
